<div
    class="flex gap-2 w-full"
    [ngClass]="wrap() ? 'flex-row items-center !gap-3' : 'flex-col'"
>
    @if (label()) {
        <app-label class="min-w-max" [required]="required()">{{
            label()
        }}</app-label>
    }
    <label
        [cdkMenuTriggerFor]="disabled() ? null : c"
        (click)="handleOpen($event)"
        [class.bg-gray-300]="disabled()"
        class="w-full border border-gray-300 rounded-xl pl-3 pr-3 py-0.5 items-center flex"
        cdkOverlayOrigin
        #trigger="cdkOverlayOrigin"
    >
        <input
            [disabled]="valid() || disabled()"
            style="caret-color: transparent"
            #yearRef
            placeholder="년"
            [(ngModel)]="year"
            class="focus-within:bg-primary-100 text-sm my-2 w-[4ch] text-end placeholder-gray-500 disabled:bg-transparent"
            maxlength="4"
            (keydown)="yearKeydown($event)"
            (paste)="handlePaste($event)"
        />
        <p class="text-sm ml-2 mr-1">-</p>
        <input
            [disabled]="valid() || disabled()"
            style="caret-color: transparent"
            #monthRef
            placeholder="월"
            [(ngModel)]="month"
            class="focus-within:bg-primary-100 text-sm w-[2ch] text-end placeholder-gray-500 disabled:bg-transparent"
            maxlength="2"
            (keydown)="monthKeydown($event)"
            (blur)="monthBlur()"
            (paste)="handlePaste($event)"
        />
        <p class="text-sm ml-2 mr-1">-</p>
        <input
            [disabled]="valid() || disabled()"
            style="caret-color: transparent"
            #dayRef
            placeholder="일"
            [(ngModel)]="day"
            class="focus-within:bg-primary-100 text-sm w-[2ch] text-end placeholder-gray-500 disabled:bg-transparent"
            maxlength="2"
            (paste)="handlePaste($event)"
            (keydown)="dayKeydown($event)"
            (blur)="dayBlur()"
        />
        <div class="flex w-full justify-end ml-2 gap-2">
            @if (!disabled()) {
                @if (year() || month() || day()) {
                    <app-icon
                        (click)="reset($event)"
                        name="ic:baseline-cancel"
                        class="!size-5 cursor-pointer text-gray-400"
                    />
                }
            }

            <app-icon
                (click)="handleOpen($event)"
                name="ic:baseline-calendar-month"
                class="!size-5 cursor-pointer text-gray-800"
            />
        </div>
    </label>
</div>

<ng-template #c>
    <div
        cdkMenu
        class="shadow-md fixed md:min-w-max md:inset-auto md:w-auto md:h-auto inset-0 items-center flex p-4 md:p-0 w-screen md:bg-transparent bg-black/70 h-screen z-[999] md:static md:top-[calc(100%+4px)]"
    >
        <app-input-calendar
            [date]="date()"
            [maxDate]="maxDate()"
            [minDate]="minDate()"
            (select)="handleSelect($event)"
        />
    </div>
</ng-template>
